import { ComponentsModule } from '../../../../../shared/components/components.module';
import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';
import { SellionsLayoutRendererLibModule } from '../../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/public-api';
import { UserTaskTemplateListPage } from './user-task-template-list';

@NgModule({
  declarations: [UserTaskTemplateListPage],
  imports: [
    SellionsLayoutRendererLibModule,
    IonicPageModule.forChild(UserTaskTemplateListPage),
    ComponentsModule,
  ],
})
export class UserTaskTemplateListModule {}



// WEBPACK FOOTER //
// ./src/modules/user-tasks/pages/user-task-list/user-task-template-list/user-task-template-list.module.ts